import axios from 'axios';
import { getApiRoot } from '../../constants/ParamountReactConstants';
import * as utils from '../../utils/Utils';

export const createReceiverRequest = ({
  receiverId,
  integrationTypeId,
  brandIds,
  selectedPriceSheetIds,
  selectedPriceTypeIds,
  withoutPrices,
  filterIds,
  withoutInterchanges,
  interchangeQualityIds,
  withoutCustomFields,
  customFieldIds,
}: {
  receiverId: number;
  integrationTypeId: number | null;
  brandIds: number[];
  selectedPriceSheetIds: number[];
  selectedPriceTypeIds: number[];
  withoutPrices: boolean;
  filterIds: number[];
  withoutInterchanges: boolean;
  interchangeQualityIds: number[];
  withoutCustomFields: boolean;
  customFieldIds: number[];
}) => {
  const urlParams = utils.createURL([
    { name: 'requesting_receiver_id', values: receiverId },
    { name: 'integration_type_id', values: integrationTypeId },
    { name: 'brand_ids', values: brandIds },
    { name: 'price_sheet_ids', values: selectedPriceSheetIds },
    { name: 'price_type_ids', values: selectedPriceTypeIds },
    { name: 'without_prices', values: withoutPrices ? 1 : 0 },
    { name: 'filter_ids', values: filterIds },
    { name: 'with_interchange_type_records', values: interchangeQualityIds },
    { name: 'without_interchanges', values: withoutInterchanges ? 1 : 0 },
    { name: 'without_custom_fields', values: withoutCustomFields ? 1 : 0 },
    { name: 'custom_field_ids', values: customFieldIds },
  ]);

  return {
    type: 'CREATE_RECEIVER_REQUESTS',
    meta: { receiverId },
    payload: axios.post(
      `${getApiRoot()}/parents/receivers/authorized_brands/request_receiver${urlParams}`
    ),
  };
};
